// extracted by mini-css-extract-plugin
module.exports = {"feature":"bVwCN","arrowIcon":"_2TmIK","title":"XqGuS"};